"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgMusic = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M16.278 2.8c.274.108.596.27.948.445l3.721 1.86a1 1 0 1 1-.894 1.79l-3.685-1.843c-.4-.2-.64-.319-.818-.388l-.029-.011-.003.03c-.017.19-.018.458-.018.906v12.414a4 4 0 1 1-2-3.468V5.548c0-.393 0-.754.027-1.047.027-.301.093-.684.334-1.03a2 2 0 0 1 1.347-.832c.416-.061.788.052 1.07.162ZM6.5 3a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0V8h-2a1 1 0 0 1 0-2h2V4a1 1 0 0 1 1-1Z", fill: "currentColor" }) }))); };
exports.default = SvgMusic;
